export function getRandomColor(name: string): string {
  const colors = [
    "#FF6B6B",
    "#4ECDC4",
    "#45B7D1",
    "#FFA07A",
    "#98D8C8",
    "#F7DC6F",
  ];
  const charCode = name.charCodeAt(0);
  return colors[charCode % colors.length];
}
